"use strict";

{
  const initCountup = () => {
    const targets = document.querySelectorAll("[data-countup]");
    if (targets.length === 0) return;

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const duration = 1500;
    const easeOutCubic = (t) => 1 - (1 - t) ** 3;

    const parseCountupValue = (text) => {
      const match = text.match(/^(\d+)(?:\.(\d+))?$/);
      if (!match) return null;
      const value = Number(text);
      if (value === 0) return null;
      return {
        finalText: text,
        value,
        decimalPlaces: match[2] ? match[2].length : 0,
      };
    };

    const formatCountupValue = (value, decimalPlaces) => {
      return decimalPlaces > 0 ? value.toFixed(decimalPlaces) : String(Math.round(value));
    };

    const animate = (el, finalText) => {
      const parsed = parseCountupValue(finalText);
      if (!parsed) return;

      const { value, decimalPlaces } = parsed;
      const start = performance.now();
      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        el.textContent = formatCountupValue(value * easeOutCubic(progress), decimalPlaces);
        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          el.textContent = finalText;
        }
      };
      requestAnimationFrame(tick);
    };

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          obs.unobserve(el);
          if (el.dataset.countupFinal) {
            animate(el, el.dataset.countupFinal);
          }
        });
      },
      { threshold: 0.4 }
    );

    targets.forEach((el) => {
      const finalText = (el.textContent || "").trim();
      const parsed = parseCountupValue(finalText);
      if (!parsed || reduceMotion) return;
      el.dataset.countupFinal = finalText;
      el.textContent = formatCountupValue(0, parsed.decimalPlaces);
      observer.observe(el);
    });
  };

  initCountup();
}
